// @flow
import type {TabItem} from './index';

/**
 * TabItems relevant for displaying NFL markets
 *
 * @ignore
 */

const NFLTabItems: [TabItem] = [
  {
    index: 0,
    title: "main",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["winner", "handicap", "most touchdowns"]
  },
  {
    index: 1,
    title: "player",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["player"]
  },
  {
    index: 2,
    title: "teams",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["team"]
  },
  {
    index: 3,
    title: "half",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["half"]
  },
  {
    index: 4,
    title: "quarter",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["quarter"]
  }
];

export { NFLTabItems };



// WEBPACK FOOTER //
// ./src/model/nfl.js